<template>
  <!--已发布页面-->
  <div class="published">
    <div class="project-content">

      <div class="basic failed" v-if="project.examineStatus == 2">
        <div class="title">
          <van-icon name="failure"/>
          审核不通过
        </div>
        <div class="content">{{ project.examineReason }}</div>
      </div>

      <div class="basic">
        <div class="title">{{ project.name }}</div>
        <div class="tagBox">
          <span class="is-auth-tag" v-show="project.isAuth === 1 && project.otherPub !== 1">已实名</span>
          <span v-show="project.category == 0">个人</span>
          <span v-show="project.category == 1">班组</span>
          <span v-show="project.category == 2">企业</span>
          <span v-if="project.workerNum !== 0">招{{ project.workerNum }}人</span>
          <span v-else>人数不限</span>
          <span v-show="project.isLatest == 1">最新发布</span>
          <span v-show="project.isFull == 1">即将招满</span>
          <span v-show="project.isLongTerm == 1">长期招聘</span>
        </div>
        <div class="textTitle" v-if="project.workTypes">工种：{{ project.workTypes }}</div>
        <div class="textTitle">发布时间： {{ project.pubTimeStr }}</div>
        <div class="textTitle">有效期：{{ project.signTime }}</div>
        <div class="textTitle">派活对象：{{ project.objects }}</div>
      </div>

      <div class="project-steps" style="z-index: 998">
        <van-image class="add-shop-btn" :src="progressImg" @click="toProjectSteps"></van-image>
      </div>
      <div class="text view-div" @click="toViewUser" v-if="project.count">
        <span class="text" style="float: right">详情 ></span>
        <span class="text">{{ project.count }}名 用户看过该招工信息</span>
      </div>
      <div class="headline">项目描述</div>
      <div class="basic clearfix">
        <div class="textTitle" ref="intro1" :class="isMore? 'retract': 'open'">{{ project.intro }}</div>
        <template v-if="haMore">
          <img src="../../assets/images/getJob/icon_zhankai.png" class="icon_zhankai" @click="isMore = !isMore"
               v-if="isMore">
          <img src="../../assets/images/getJob/icon_shouqi.png" class="icon_zhankai" @click="isMore = !isMore"
               v-else>
        </template>
      </div>
      <div class="headline">招工方</div>
      <div class="basic" v-if="project.otherPub !== 1">
        <div class="hireParty">
          <div class="personLogo">
            <img src="../../assets/images/publicImg/touxiang_default.png" v-if="!project.img">
            <img :src="project.img" v-else>
          </div>
          <div class="rightContainer">
            <div class="textTitle" style="font-weight: bold;margin-bottom: 0;line-height: 22px">{{
                project.pubName
              }}
            </div>
            <div class="WRAST clearfix">
              <div class="inlineStyle">
                <span class="textTitle" v-if="project.creditStar.socreLevel == -1">黑名单</span>
                <span class="textTitle" v-if="project.creditStar.socreLevel == 0">信用未评级</span>
                <img src="../../assets/images/getJob/icon_star_1.png" class="star_one"
                     v-if="project.creditStar.starCount === 1">
                <img src="../../assets/images/getJob/icon_star_2.png" class="star_two"
                     v-if="project.creditStar.starCount === 2">
                <img src="../../assets/images/getJob/icon_star_3.png" class="star_three"
                     v-if="project.creditStar.starCount === 3">
                <img src="../../assets/images/getJob/icon_star_4.png" class="star_four"
                     v-if="project.creditStar.starCount === 4">
                <img src="../../assets/images/getJob/icon_star_5.png" class="star_five"
                     v-if="project.creditStar.starCount === 5">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="basic" v-else>
        <div class="otherPubBox">
          <div class="leftBox">
            <div class="personLogo">
              <img src="../../assets/images/publicImg/touxiang_default.png" v-if="!project.img">
              <img :src="project.img" v-else>
            </div>
            <div class="textTitle" style="font-weight: bold;height: 20px;margin-bottom: 0">{{
                project.personName
              }}
            </div>
          </div>
          <img src="../../assets/images/getJob/btn_phoneDai.png" class="btn_phoneDai"
               @click="callPhone(project.mobile)">
        </div>
      </div>

      <template v-if="project.lng && project.lat">
        <div class="headline">项目地址</div>
        <div class="basic">
          <template>
            <div class="icon_dizhiBox">
              <img src="../../assets/images/publicImg/icon_dizhi.png" class="icon_dizhi">
              <span class="textTitle">{{ project.address }}</span>
            </div>
            <div class="mapbox">
              <div class="map" id="container"></div>
            </div>
            <div class="hint">提示：点击地图可导航</div>
          </template>
        </div>
      </template>

      <div class="headline" v-if="project.attachs !== undefined && project.attachs.length > 0">附件</div>

      <div class="basic" v-if="project.attachs !== undefined && project.attachs.length > 0">
        <div style="display: flex;">
          <div class="fileContainerBox" v-for="(item, index) in project.attachs" :key="index"
               @click="attDetail(item, index)">
            <div class="fileBox"
                 v-if="item.fileType ==='jpg' || item.fileType ==='png' || item.fileType ==='jpeg' || item.fileType ==='mp4'">
              <div style="position: relative">
                <div v-if="item.fileType ==='mp4'" class="videoBox">
                  <video :poster="item.attachUrl+'?x-oss-process=video/snapshot,t_1,m_fast'" :src="item.attachUrl"
                         class="video"></video>
                  <img src="../../assets/images/publicImg/icon_video_bg.png" class="file-img icon_video_bg">
                </div>
                <img class="file-img" :src="item.attachUrl"
                     v-if="item.fileType ==='jpg' || item.fileType ==='png' || item.fileType ==='jpeg'">
              </div>
            </div>
          </div>
        </div>
        <div class="fileContainer" v-for="(item, index) in project.attachs" :key="index"
             @click="attachsDetail(item.attachUrl)"
             v-if="item.fileType !=='jpg' && item.fileType !=='png' && item.fileType !=='jpeg' && item.fileType !=='mp4'">
          <span v-if="item.fileType ==='pdf'" class="icon_pdf"></span>
          <span v-else-if="item.fileType ==='xls' || item.fileType ==='xlsx'" class="icon_excel"></span>
          <span v-else-if="item.fileType ==='doc' || item.fileType ==='docx'" class="icon_word"></span>
          <span v-else-if="item.fileType ==='ppt' || item.fileType ==='pptx'" class="icon_ppt"></span>
          <span v-else class="icon_file_default"></span>
          <span class="attachName">{{ item.attachName }}</span>
        </div>
        <div class="hint">
          提示：点击预览或下载附件
        </div>
      </div>

      <div class="project-steps" style="z-index: 998">
        <van-image class="add-shop-btn" :src="progressImg" @click="toProjectSteps"></van-image>
      </div>

    </div>
    <div style="height: 1px"></div>

    <imagePopup v-model="showImagePopup" :imgUrl="imgUrl"/>

    <van-dialog
      style="width:100%;border-radius:0;height:200px"
      theme="default"
      v-model="showvideoplay"
      :show-cancel-button="false"
      :show-confirm-button="false"
      closeOnClickOverlay
    >

      <div ref="videobox" id="mui-player"></div>
    </van-dialog>
    <div id="video-ios" style="height: 0"></div>
  </div>
</template>

<script>
import {
  getSimpleProjectInfo,
  getFinishStatus,
  finishApply,
  userEnough,
  delProject,
  getProjectSigns,
  getProjectAccepts
} from '@api/project'
import { dataSave } from '@api/coins'
import imagePopup from '@components/imagePopup/imagePopup'
import { callByCoin, onceCallCoins } from '@api/integralMall'
import progressImg from '../../assets/images/project/project_btn_progress.png'
import actionBar from '@/components/actionBar'
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'
import { ImagePreview } from 'vant'

export default {
  name: 'published',
  components: { imagePopup, actionBar },

  data () {
    return {
      progressImg: progressImg,
      isMyRelease: 0,
      finishStatus: '',
      id: '',
      active: '1',
      showImagePopup: false,
      imgUrl: '',
      project: {},

      isMore: true,
      haMore: false,
      showPopover: false,
      showvideoplay: false
    }
  },
  created () {
    this.token = localStorage.getItem('token')
    this.startTime = Date.now()

    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.status = this.$route.query.status
    this.isMyRelease = this.$route.query.isMyRelease
    // 客户端调用js方法-语音输入
    this.$bridge.registerHandler('SpeechInput', (data, responseCallback) => {
      this.form.intro = this.form.intro + data
      responseCallback(data)
    })
    this.getSimpleProjectInfo()

    // 初始化极光统计
    this.$jiguang.initCountEvent()
  },
  mounted () {
    setTimeout(() => {
      this.adMap()
    }, 1000)

    // 支付回调
    this.$bridge.registerHandler('paySuccess', (data, responseCallback) => {
      this.payment()
    })
  },
  methods: {

    // 招工方详情
    hirePartyDetail () {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/hirePartyDetail?id=${this.project.pubCompanyId}&category=${this.project.category}&projectId=${this.project.id}`,
        title: '基本信息'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    beforeChange () {
      if (this.project.examineStatus == 2) {
        this.$toastMsg('信息审核不通过')
        return false
      } else {
        return true
      }
    },

    // 获取指定所需邀工币数量
    onTop () {
      if (this.project.examineStatus == 2) {
        this.$toastMsg('信息审核不通过')
        return
      }
      this.topByCoin()
    },

    // 置顶
    topByCoin () {

      let dataJson = {
        dataId: this.id,
        dataType: '1'
      }
      // 暂时储存临时数据
      dataSave(dataJson).then(res => {
        if (res.data.code === 200) {
          let data
          if (this.project.isTop == 1) {
            data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=4&uid=` + res.data.data + '&id=' + this.id,
              title: '招工信息置顶'
            }
          } else {
            data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=4&uid=` + res.data.data,
              title: '招工信息置顶'
            }
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        }
      })
    },
    adMap () {
      var map = new AMap.Map('container', {
        zoom: 14, // 缩放级别
        center: this.center, // 设置地图中心点
        resizeEnable: false // 地图初始化加载定位到当前城市
      })
      // 获取初始中心点并赋值
      this.marker = new AMap.Marker({
        map: map,
        position: this.center
      })
      this.marker.setLabel({
        offset: new AMap.Pixel(20, 20) // 修改label相对于maker的位置
      })
      var currentCenter = map.getCenter()// 此方法是获取当前地图的中心点
      this.center = [currentCenter.lng, currentCenter.lat]// 将获取到的中心点的纬度经度赋值给data的center
    },

    // 打开地图
    openMap () {
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_map_click', response => {
        console.log('response:', response)
      })

      this.$bridge.callHandler('openAmap', response => {
        console.log('response:', response)
      })
      this.marker.markOnAMAP({
        position: this.marker.getPosition()
      })
    },

    // 查看访问用户
    toViewUser () {
      // this.enterRouter('projectViewUser', {projectId: this.id})
      const data = {
        title: '谁看过招工广告',
        url: `${process.env.VUE_APP_BASE_HOST}/projectViewUser?projectId=${this.id}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 查看项目进度
    toProjectSteps () {
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_project_info_browser,项目信息详情,项目,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_project_view_steps', response => {
        console.log('response:', response)
      })

      if (!localStorage.getItem('token')) {
        this.$toastMsg('请先登录')
        return
      }
      // this.enterRouter('projectSteps', {projectId: this.id})
      const data = {
        title: '项目进度',
        url: `${process.env.VUE_APP_BASE_HOST}/projectSteps?projectId=${this.id}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 下载附件
    attDetail (file, index) {

      if (file.fileType === 'mp4') {
        // 判断ios还是安卓
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {

          const video = document.getElementById('playVideos')
          if (video) {
            video.remove()
          }

          let str = document.createElement('video')
          str.id = 'playVideos'
          str.src = file.attachUrl
          str.setAttribute('type', 'video/mp4')
          str.setAttribute('controls', 'controls')
          str.style.width = '0'
          str.style.height = '0'
          str.play()
          document.getElementById('video-ios').append(str)
        } else {
          this.$bridge.callHandler('newPage', { url: file.attachUrl }, response => {
            console.log('response:', response)
          })
          return
          this.showvideoplay = true

          setTimeout(function () {
            // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
            var mp = new MuiPlayer({
              container: '#mui-player',
              title: '视频',
              src: file.attachUrl,
              preload: 'auto',
              autoplay: true
            })
          }, 500)
        }
      } else {
        let list = []
        for (let i = 0; i < this.project.attachs.length; i++) {
          if (this.project.attachs[i].fileType === 'jpg' || this.project.attachs[i].fileType === 'png' || this.project.attachs[i].fileType === 'jpeg') {
            list.push(this.project.attachs[i].attachUrl)
          } else {
            if (i <= index) {
              index = index - 1
            }
          }
        }

        ImagePreview({
          images: list,
          showIndex: true,
          loop: false,
          startPosition: index
        })
      }
    },

    attachsDetail (attachUrl) {
      this.$bridge.callHandler('newPage', { url: attachUrl }, response => {
        console.log('response:', response)
      })
    },
    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    },
    // 我发布的 分页获取简易项目报名人员
    getProjectSigns () {
      this.pageNum++
      this.incomeListLoading = true
      getProjectSigns({
        projectId: this.id,
        pageNum: this.pageNum,
        pageSize: 10
      }).then(res => {
        console.log('getProjectSigns==', res)
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list = this.list.concat(res.data.data.rows)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 我发布的 分页获取简易项目签约人员
    getProjectAccepts () {
      this.pageNum++
      this.incomeListLoading = true
      getProjectAccepts({
        projectId: this.id,
        pageNum: this.pageNum,
        pageSize: 10
      }).then(res => {
        console.log('getProjectSigns==', res)
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list = this.list.concat(res.data.data.rows)

            console.log('list，==', this.list)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    tabClick (name) {
      this.pageNum = 0
      this.pageSize = 10
      this.list = []
      this.incomeListLoading = true
      this.listLoadFinished = false
      if (name === '1') {
        this.getSimpleProjectInfo()
      } else if (name === '2') {
        this.getProjectSigns()
      } else {
        this.getProjectAccepts()
      }
    },
    onLoad () {
      // 上拉加载
      if (this.active === '2') {
        this.getProjectSigns()
      } else if (this.active === '3') {
        this.getProjectAccepts()
      }
    },
    detail (id, unitId) {
      let type
      let title
      if (this.active === '2') {
        type = 1
        title = '报名人'
      } else {
        type = 2
        title = '签约人'
      }
      // this.enterRouter('userInfo', {joinId: id, projectId: this.id, status: this.status, type: type})
      // 客户端跳转
      const data = {
        title: title,
        url: `${process.env.VUE_APP_BASE_HOST}/userInfo?joinId=${id}&projectId=${this.id}&type=${type}&status=${this.status}&unitId=${unitId}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    // 获取项目详情
    getSimpleProjectInfo () {
      getSimpleProjectInfo({ id: this.id }).then(res => {
        if (res.data.code === 200) {
          this.project = res.data.data
          this.center = [this.project.lng, this.project.lat]

          // 判断渲染简介展开收起
          setTimeout(() => {
            let intro1 = this.$refs.intro1
            if (intro1) {
              if (intro1[0].scrollHeight > 130) {
                this.haMore = true
                this.isMore = true
              } else {
                this.isMore = false
              }
            }
            let intro2 = this.$refs.intro2
            if (intro2) {
              if (intro2.scrollHeight > 130) {
                this.haMore = true
                this.isMore = true
              } else {
                this.isMore = false
              }
            }
          }, 100)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 获取项目状态
    getFinishStatus () {
      getFinishStatus({ projectId: this.id }).then(res => {
        if (res.data.code === 200) {
          this.finishStatus = res.data.data.finishStatus
          this.finishId = res.data.data.finishId
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 已招满
    userEnough () {
      if (this.project.examineStatus == 2) {
        this.$toastMsg('信息审核不通过')
        return
      }
      userEnough({ id: this.id }).then(res => {
        console.log('res=', res)
        if (res.data.code === 200) {
          this.$toast.success('操作成功')
          // 延迟1秒
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 删除项目
    delProject () {
      this.$dialog.confirm({
        title: '删除',
        message: '确认删除该项目吗？'
      }).then(() => {
        delProject({ id: this.id }).then(res => {
          console.log('res=', res)
          if (res.data.code === 200) {
            this.$toast.success('删除成功')
            // 延迟1秒
            setTimeout(() => {
              this.$bridge.callHandler('backRefresh', response => {
                console.log('response:', response)
              })
            }, 1000)
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }).catch(() => {
        // on cancel
      })
    },
    // 分享
    shareProject () {
      this.showPopover = false
      let content = ''
      if (this.project.city) {
        content = this.project.city
      }
      if (this.project.name) {
        content = content + this.project.name
      }

      const data = {
        city: localStorage.getItem('cityCode'),
        content: content,
        fileUrl: [this.project.headImg],
        visible: 1,
        type: 2,
        url: `/getJobJianYiDetail?projectId=${this.id}`,
        imId: this.project.imId,
        projectId: this.id
      }
      this.$bridge.callHandler('share', data, response => {
        console.log('response:', response)
      })
    },
    applyCompletion () {
      // 单位标识：0-招标方；1-投标方
      // finishFlag:项目完工标识：0-未申请；1-申请中；2-被驳回;3-申请已通过
      this.$dialog.confirm({
        title: '完工申请',
        message: '确认发送完工申请？'
      }).then(() => {
        let browTime = parseInt((Date.now() - this.startTime) / 1000)
        let brow = 'h5_project_info_browser,项目信息详情,项目,' + browTime
        // 初始化极光统计预览时长
        this.$jiguang.initBrowseEvent(brow)
        // 获取极光统计所需数据
        this.$bridge.callHandler('getDeviceInfo', 'h5_project_application_completion', response => {
          console.log('response:', response)
        })
        // 发送完工申请
        this.applySubmit()
      }).catch(() => {
        // on cancel
      })
    },
    applySubmit () {
      finishApply({
        projectId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          this.$toast.success('操作成功')
          // 延迟1秒
          setTimeout(() => {
            this.$bridge.callHandler('backRefresh', response => {
              console.log('response:', response)
            })
          }, 1000)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 查看驳回原因
    rejectionReasons () {
      const data = {
        title: '项目消息',
        url: `${process.env.VUE_APP_BASE_HOST}/applyReject?id=${this.finishId}`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    // 调用拨号功能
    callPhone () {
      onceCallCoins({
        dataType: 1,
        dataId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.firstFlag === true) {
            // 获取极光统计所需数据
            this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert', response => {
              console.log('response:', response)
            })

            this.$dialog.confirm({
              title: '拨打电话',
              message:
                `拨打电话，需要支付${res.data.data.value}个邀工币。`,
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                this.payment()
              })
              .catch(() => {
                // on cancel
              })
          } else {
            callByCoin({
              dataType: 1,
              dataId: this.id
            }).then(res => {
              if (res.data.code === 200) {
                const phoneNumber = res.data.data.phone
                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              }
            })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    payment () {
      callByCoin({
        dataType: 1,
        dataId: this.id
      }).then(res => {
        if (res.data.code === 200) {
          // 判断邀功币不足
          if (res.data.data.enough == 0) {
            const data = {
              title: '邀工币充值',
              url: `${process.env.VUE_APP_BASE_HOST}/coinsPay?coinRemain=` + res.data.data.coinRemain + '&coinNeed=' + res.data.data.coinNeed
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          } else {
            const phoneNumber = res.data.data.phone
            this.$dialog.confirm({
              title: '拨打电话',
              message:
                '支付完成，您可以拨打电话',
              confirmButtonColor: '#096CEFFF'
            })
              .then(() => {
                // 获取极光统计所需数据
                this.$bridge.callHandler('getDeviceInfo', 'callPhone_alert_confirm', response => {
                  console.log('response:', response)
                })

                const data = { phone: phoneNumber }
                this.$bridge.callHandler('callPhone', data, response => {
                  console.log('response:', response)
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 签约后拨打电话（直接拨打电话号码）
    tellPhone (phone) {
      const data = { phone: phone }
      this.$bridge.callHandler('callPhone', data, response => {
        console.log('response:', response)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/mixin";

#mui-player {
  height: 200px !important;
}

.published {
  padding-bottom: 80px;

  .fileContainerBox {
    display: flex;
    align-items: center;
    width: auto;
  }

  .fileBox {
    display: flex;
    flex-wrap: wrap;

    .file-img {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
      flex-shrink: 0;
    }

    .videoBox {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
    }

    .icon_video_bg {
      width: 80px;
      height: 80px;
      position: absolute;
      top: 0px;
      left: 0;
      z-index: 0;
    }

    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .icon-attachDelete {
      font-size: 19px;
      color: #FFFFFF;
      position: absolute;
      top: 12px;
      right: 0;
    }
  }

  .tagBox {
    span {
      display: inline-block;
      @include add_size($font_size_13);
      color: #096CEF;
      min-height: 20px;
      padding: 0 5px;
      text-align: center;
      background: rgba(9, 108, 239, 0.07);
      margin-right: 8px;
      border-radius: 2px;
      border: 1px solid #8DBEFE;

      &:last-child {
        margin-right: 0;
      }
    }

    margin-bottom: 10px;
  }

  .headline {
    margin: 0 0 10px 12px;
    @include add_size($font_size_17);
    color: #333333;
    font-weight: bold;
    border-left: 3px solid #096CEF;
    padding-left: 4px;
    height: 15px;
    line-height: 14px;
  }

  .basic {
    background-color: #fff;
    padding: 12px;
    color: #333;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
    margin-bottom: 12px;

    .title {
      @include add_size($font_size_18);
      font-weight: 600;
    }

    .textTitle {
      @include add_size($font_size_16);
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .hint {
      @include add_size($font_size_15);
      color: #999;
    }

    .mapbox {
      width: 100%;
      height: 190px;
      position: relative;

      #container {
        width: 100%;
        height: 100%;
      }
    }

    .personLogo {
      margin-right: 10px;

      img {
        border-radius: 5px;
        width: 48px;
        height: 48px;
      }
    }

    #container {
      width: 100%;
      height: 197px;
      margin-top: 8px;
    }

    .hireParty {
      display: flex;

      span {
        vertical-align: middle;
      }
    }

    .otherPubBox {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .leftBox {
        display: inherit;
        align-items: center;
      }

      .btn_phone {
        width: 69px;
        height: 21px;
      }
    }

    .phoneBox {
      display: flex;
      border-top: 1px solid #ccc;
      padding-top: 9px;
      margin: 16px -12px 0;

      div {
        flex: 1;

        &:first-child {
          border-right: 1px solid #ccc;
          margin: -9px 0;
        }
      }

      img {
        height: 21px;
        margin: 0 auto;
      }

      .btn_addFriend {
        width: 84px;
        margin-top: 9px;
      }

      .btn_addFriendDis {
        width: 69px;
        margin-top: 9px;
      }

      .btn_phone {
        width: 69px;
        flex: 1;
      }
    }

    .retract {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }
  }

  .company {
    padding: 15px 0px 20px 12px;
  }

  .other-file-type {
    text-align: center;
    line-height: 84px;
    color: white;
    @include add_size($font_size_14);
  }

  .attachName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rightContainer {
    width: 100%;
  }

  .WRAST {
    position: relative;
    height: 20px;
    line-height: 22px;
    vertical-align: middle;

    .star_one {
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_two {
      width: 40px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_three {
      width: 60px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_four {
      width: 80px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .star_five {
      width: 100px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .icon_more {
      float: right;
      width: 45px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
    }

    .btn_phone {
      float: right;
      margin-right: 15px;
      width: 100px;
      height: 30px;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .icon_zhankai {
    width: 48px;
    height: 20px;
    float: right;
  }
}

.published {
  padding-bottom: 60px;
}

.hint {
  @include add_size($font_size_15);
  color: #999;
}

.hireParty {
  display: flex;

  span {
    vertical-align: middle;
  }

  .iconImg {
    display: inline-block;
    vertical-align: middle;
    margin-left: 8px;
  }

  .tagImg {
    margin-top: 5px;
    float: right;
    width: 29px;
    height: 20px;
    background: url("../../assets/images/publicImg/icon_personage.png") center no-repeat;
    background-size: contain;
  }

  .banzhuImg {
    margin-top: 5px;
    float: right;
    width: 29px;
    height: 20px;
    background: url("../../assets/images/publicImg/icon_group.png") center no-repeat;
    background-size: contain;
  }

  .qiyeImg {
    margin-top: 5px;
    float: right;
    width: 29px;
    height: 20px;
    background: url("../../assets/images/publicImg/icon_company.png") center no-repeat;
    background-size: contain;
  }

  .common_tag_shiming {
    width: 52px;
    height: 20px;
    background: url("../../assets/images/publicImg/common_tag_shiming.png") center no-repeat;
    background-size: contain;
  }

  .common_tag_weishiming {
    width: 52px;
    height: 20px;
    background: url("../../assets/images/publicImg/common_tag_weishiming.png") center no-repeat;
    background-size: contain;
  }
}

.personLogo {
  margin-right: 10px;

  img {
    border-radius: 5px;
    width: 68px;
    height: 68px;
  }
}

.rightContainer {
  line-height: 24px;
  width: 100%;
}

.WRAST {
  /*display: flex;*/
  /*justify-content: space-between;*/
  /*align-items: center;*/

  .star_one {
    width: 26px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_two {
    width: 52px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_three {
    width: 78px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_four {
    width: 104px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }

  .star_five {
    width: 130px;
    height: 26px;
    display: inline-block;
    vertical-align: middle;
  }

  .btn_phone {
    float: right;
    margin-right: 15px;
    width: 100px;
    height: 30px;
    display: inline-block;
    vertical-align: middle;
  }
}

.btn_phoneDai {
  float: right;
  margin-right: 8px;
  width: 94px;
  height: 28px;
  display: inline-block;
  vertical-align: middle;
}

.headImg {
  width: 115px !important;
  height: 115px !important;
  border-radius: 5px;
  margin-right: 10px;
}

.basic {
  padding: 15px 15px 20px 15px;
}

.company {
  padding: 15px 0px 20px 15px;
}

hr {
  border: none;
  height: 1px;
  margin-bottom: 18px;
  background-color: #e2e2df;
}

.type-hr {
  margin-top: 18px;
}

.type-text {
  @include add_size($font_size_22);
  padding-top: 10px;
  /*font-weight: bold;*/
}

.icon_dizhiBox {
  @include add_size($font_size_18);

  .icon_dizhi {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
  }

  span {
    vertical-align: middle;
  }
}

.project-content {
  margin: 15px 0 70px 0;

  .failed {
    margin-top: 10px;
    border: 1px solid rgba(242, 54, 54, 0.5);
    background-color: #F236360D;

    padding: 10px;

    .title {
      color: #F23636FF;
      @include add_size($font_size_20);
      font-size: 18px;
      padding-bottom: 5px;

      .van-icon {
        @include add_size($font_size_20);
        vertical-align: -15%;
      }
    }

    .content {
      @include add_size($font_size_16);
    }
  }

  .project-steps {
    position: fixed;
    right: 0;
    bottom: 20%;

    .add-shop-btn {
      width: 100px;
    }
  }

  .textTitle {
    @include add_size($font_size_16);
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .text {
    @include add_size($font_size_17);
    font-weight: 400;
  }

  .other-file-type {
    text-align: center;
    line-height: 84px;
    color: white;
    @include add_size($font_size_14);
  }

  .attachName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.view-div {
  @include add_size($font_size_17);
  background: rgba(9, 108, 239, 0.1);
  color: #096CEF;
  border-radius: 50px;
  margin: 0 15px 10px 15px;
  padding: 6px 15px
}

.project-btn-div {
  display: flex;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  padding: 10px;
  background-color: white;
  border-top: 0.5px solid #EEEEEE;

  .van-button {
    margin: 0 4px;
    font-size: 17px;
    height: 35px;
  }

  .btn-1 {
    width: 28%;
  }

  .btn-2 {
    width: 28%;
  }

  .btn-3 {
    width: 28%;
  }

  .btn-4 {
    width: 80%;
    margin: 0 auto;
  }

  .showPopover {
    display: inline-block;
    margin-right: 8px;
    margin-left: 4px;
  }

  .xiangqing_dots {
    width: 22px;
    margin-top: 10px;
  }

  .van-button--normal {
    padding-left: 12px;
    padding-right: 12px;
  }
}

.mapbox {
  width: 100%;
  height: 197px;
  position: relative;

  #container {
    width: 100%;
    height: 197px;
    margin-top: 8px;
  }
}

</style>
<style lang="scss">
.van-popover {
  width: 100px;

  .van-popover__content {
    /*padding: 16px;*/
  }

  .btn_delete {
    width: 22px;
    display: inline-block;
    vertical-align: middle;
  }

  .btn_text {
    font-size: 16px;
    vertical-align: middle;
    margin-left: 8px;
  }

  .popoverDiv {
    margin-bottom: 10px;
    text-align: center;
  }
}
</style>
